/**
 * Texte simple ou riche : la forme d'un texte du quiz de prérequis (une question, dans le quiz et
 * dans sa correction).
 *
 * Le rendu riche est `<RichText>`, le moteur de Sam et de l'énoncé (markdown et formules, Wajih,
 * 18/10). Sur téléphone, chaque `<RichText>` est une WebView, qui charge le moteur de formules et se
 * mesure avant de prendre sa hauteur : une par question ferait d'un quiz de dix questions dix
 * WebViews. Or environ 0,2 % des questions portent une formule. Le rendu riche n'est donc monté que
 * pour un texte qui contient une formule ; le reste reste du texte.
 *
 * Une formule, ce sont les délimiteurs que le moteur lit : `$…$`, `$$…$$`, `\(…\)` et `\[…\]`. Un
 * dollar seul (« 5 $ ») n'en est pas une, ni le passage entre deux prix (« 5 $ et un stylo 2 $ ») :
 * entre deux dollars simples, le passage ne commence ni ne finit par une espace (la règle de pandoc).
 */
export type QuizTextFormat = "plain" | "rich"

const FORMULA = /\$\$[\s\S]+?\$\$|\$[^\s$](?:[^$\n]*[^\s$])?\$|\\\([\s\S]+?\\\)|\\\[[\s\S]+?\\\]/

export function hasFormula(text: string | null | undefined): boolean {
    return text != null && FORMULA.test(text)
}

export function quizTextFormat(text: string | null | undefined): QuizTextFormat {
    return hasFormula(text) ? "rich" : "plain"
}
